/**
 * @description Идентификатор действия запроса количества новых уведомлений в Whats App.
 * @type {string}
 */
export const WHATS_APP_NOTIFICATION_REQUEST = 'WHATS_APP_NOTIFICATION_REQUEST';

export default WHATS_APP_NOTIFICATION_REQUEST;
